import React, { useContext, useState, useEffect } from 'react';
import { navigate } from '@reach/router';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { connect } from 'react-redux';
import * as yup from 'yup';
import classNames from 'classnames';
import _ from 'lodash';
import { ModalFooter, Button } from 'reactstrap';
import { parsePhoneNumber } from '@eb/libphonenumber'
import v from 'scss/v';
import styled from 'styled-components';
import { I18N, GlobalContext } from 'commons';
import SaveAndContinueButton from 'commons/SaveAndContinueButton';
import { goNextPage, isEditPage } from 'utils/ebUtils';
import SaveButton from 'commons/SaveButton';
import CancelButton from 'commons/CancelButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import DropDownWithLabel from '../DropDownWithLabel';
import ContactPathsSection from './ContactPathsSection';
import FirstNameSection from './FirstNameSection';
import LastNameSection from './LastNameSection';
import ExternalIdSection from './ExternalIdSection';
import RegistrationEmailSection from './RegistrationEmailSection';
import { cookies, orgId } from "../../../utils";
import { PREFERREDLANGUAGENOTPROVIDED } from 'constants/applicationConstant';

const SaveButtonContainer = styled.div`
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  z-index:2001;
  position: relative;
  @media only screen and (max-width: ${v('$small-screen')}px) {
    justify-content: center;
  }
`;

const StatusContainer = styled.div`
  margin: 10px;
`;

const ContactHeader = styled.h3`
  font-size: 1.25rem;
  padding: 1rem 0px;
`;

const ContactHeaderLoggedIn = styled.h2`
  font-size: 1.25rem !important;
  padding: 1rem 0px !important;
  background: none !important;
`;
const InnerForm = ({
  values,
  handleChange,
  handleBlur,
  handleSubmit,
  contactPaths,
  setFieldValue,
  setFieldError,
  status,
  errors,
  touched,
  setFieldTouched,
  contactPathError,
  setContactPathError,
  isNeedValidation,
  setIsNeedValidation,
  isMinContactPathNumShow,
  minContactPathNum,
  contactId,
  preferredLanguage,
  profileTimeZones,
  isPreferredLanguageEditable,
  isPreferredLanguageMandatory,
  preferredLanguageList,
  isAllFieldMandatory,
  profilesData,
  isValidating,
  isTimeZoneExposed,
  isTimeZoneEditable,
  isTimeZoneMandatory
}) => {
  const {
    isInLoggedInEditProfileMode,
    organization: { isUseDeviceTimeFrame, shouldShowPreferredLanguage }
  } = useContext(GlobalContext);
  const { firstName, lastName, timeZone, suffix, middleInitial, externalId, email: registrationEmail, isEmailEditable } = values;
  const isSuccessSubmit = _.get(status, 'success');
  const isShowInfo = minContactPathNum > 0;
  const isNewEditPage = isEditPage('edit-profile');
  const [contactPathErrorTmp, setContactPathErrorTmp] = useState(contactPathError);
  const updateContactPathError = (name, value) => {
    if (value === 'delete') {
      delete contactPathError[name];
    } else {
      contactPathError[name] = value;
    }
    setContactPathErrorTmp({ ...contactPathError });
  };

  const entryFromPublicPortal = cookies.get("entryFromPublicPortal", {
    path: `/${orgId}`
  });

  const [iscallOutMsgShow, setIscallOutMsgShow] = useState(false);
  const [onClickSave, setOnClickSave] = useState(false);

  useEffect(() => {
    let errorFocusTimer;
    if (onClickSave && !isValidating) {
      if (!_.isEmpty(errors)) {
        const errorList = Object.keys(errors);
        const element = document.getElementById(errorList[0]);
        if (errorList.length > 0 && element?.focus) {
          element.focus();
          setOnClickSave(false);
        }
      } else {
        const contactPathErrorList = Object.keys(contactPathErrorTmp);
        if (!isNeedValidation && contactPathErrorList.length > 0) {
          errorFocusTimer = setTimeout(() => {
            for (const path of contactPaths) {
              const pathError = _.find(contactPathErrorList, (error) => {
                const pathId = error.replace('contactPath--', '');
                return pathId === path.pathId.toString();
              });
              if (pathError) {
                document.getElementById(pathError)?.focus();
                setOnClickSave(false);
                break;
              }
            }
          }, 300);
        } else {
          clearTimeout(errorFocusTimer);
        }
      }
    }
  }, [isValidating, onClickSave, contactPathErrorTmp, isNeedValidation]);

  const modifiedPreferredLanguage = preferredLanguageList.filter(o=>o.selected || o.id===preferredLanguage);

  return (
    <div>
      <form>
        <div className="form-group row pt-4 p-2">
          <div className="col-md-12">
            <div>
              <FirstNameSection
                firstName={firstName}
                middleInitial={middleInitial}
                onChange={event => {
                  setIsNeedValidation(false);
                  return handleChange(event);
                }}
                onBlur={event => {
                  setIsNeedValidation(false);
                  return handleBlur(event);
                }}
                errors={errors}
                touched={touched}
                data={profilesData.firstName}
              />
              <LastNameSection
                lastName={lastName}
                suffix={suffix}
                onChange={event => {
                  setIsNeedValidation(false);
                  return handleChange(event);
                }}
                onBlur={event => {
                  // debugger;
                  setIsNeedValidation(false);
                  return handleBlur(event);
                }}
                errors={errors}
                touched={touched}
                data={profilesData.lastName}
              />
              <ExternalIdSection
                externalId={externalId}
                onChange={event => {
                  setIsNeedValidation(false);
                  return handleChange(event);
                }}
                onBlur={event => {
                  setIsNeedValidation(false);
                  return handleBlur(event);
                }}
                errors={errors}
                touched={touched}
              />
              {
                !_.isEmpty(profilesData.email) &&
                <RegistrationEmailSection
                  registrationEmail={registrationEmail}
                  onChange={event => {
                    setIsNeedValidation(false);
                    return handleChange(event);
                  }}
                  onBlur={event => {
                    setIsNeedValidation(false);
                    return handleBlur(event);
                  }}
                  errors={errors}
                  touched={touched}
                  disabled={!isEmailEditable}
                />
              }
              {
                ((shouldShowPreferredLanguage && modifiedPreferredLanguage?.length>0) &&
                  <DropDownWithLabel
                    onChange={event => {
                      setIsNeedValidation(false);
                      return handleChange(event);
                    }}
                    onBlur={handleBlur}
                    defaultValue={preferredLanguage}
                    field="preferredLanguage"
                    testSelector="ssp_myprofile_preferredLanguage"
                    label="ssp.register.preferredLanguage"
                    emptyOptionValue={!isPreferredLanguageEditable && PREFERREDLANGUAGENOTPROVIDED || undefined}
                    list={modifiedPreferredLanguage}
                    disabled={!isPreferredLanguageEditable}
                    mandatory={isPreferredLanguageMandatory && isPreferredLanguageEditable}
                    error={touched.preferredLanguage && errors.preferredLanguage}
                  />)
              }
              {
                profileTimeZones.length && isTimeZoneExposed &&
                <DropDownWithLabel
                  onChange={event => {
                    setIsNeedValidation(false);
                    return handleChange(event);
                  }}
                  onBlur={handleBlur}
                  field="timeZone"
                  label="contact.path.device.time.frame.quiet.time.timezone"
                  defaultValue={timeZone || ''}
                  testSelector="ssp_myprofile_timezone"
                  list={profileTimeZones.map(o=>({...o, displayLabel: o.displayLabel.replace(':', ' ')}))}
                  disabled={!isTimeZoneEditable}
                  mandatory={isTimeZoneMandatory}
                  error={touched.timeZone && errors.timeZone}
                />
              }
            </div>
            <div className="form-group row" />
            <div className="col-md-12 contact-info pl-0 pr-0">
              {
                isInLoggedInEditProfileMode ?
                  <ContactHeaderLoggedIn className="h3-gray">
                    <I18N>new.registration.signup.create.account.label.contactInformation</I18N>
                  </ContactHeaderLoggedIn> :
                  <ContactHeader className="h3-gray">
                    <I18N>new.registration.signup.create.account.label.contactInformation</I18N>
                  </ContactHeader>
              }
              {
                !isAllFieldMandatory && isShowInfo &&
                  <p className="content">
                    <I18N>
                      {`new.registration.ssp.path.complete.at.least, ${minContactPathNum}`}
                    </I18N>
                  </p>
              }
              {
                isInLoggedInEditProfileMode && isUseDeviceTimeFrame &&
                <p className="content">
                  <I18N>new.registration.ssp.path.receive.notification.tip</I18N>
                </p>
              }
              {
                contactPaths.length > 0 &&
                <ContactPathsSection
                  isAllFieldMandatory={isAllFieldMandatory}
                  contactPaths={contactPaths}
                  minContactPathNum={minContactPathNum}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  values={values}
                  setFieldError={setFieldError}
                  touched={touched}
                  setFieldTouched={setFieldTouched}
                  contactPathError={contactPathError}
                  setContactPathError={updateContactPathError}
                  isNeedValidation={isNeedValidation}
                  setIsNeedValidation={setIsNeedValidation}
                  isMinContactPathNumShow={isMinContactPathNumShow}
                  isEditMode={isInLoggedInEditProfileMode}
                  setIscallOutMsgShow={setIscallOutMsgShow}
                />
              }

            </div>
            {
              iscallOutMsgShow &&
              <div className="col-md-12">
                <div className="row">
                  <div className="alert alert-info mt-4">
                    <FontAwesomeIcon icon={faInfoCircle} color={v('$blue-7')} width="1em" height="1em" />
                    <div className="ml-2">
                      <I18N
                        tag={isInLoggedInEditProfileMode ? 'h3' : 'h4'}
                        className="please-note-h"
                      >
                        ssp.myprofile.callOut.title
                      </I18N>
                      <p className="mb-0"><I18N>ssp.myprofile.callOut.message</I18N></p>
                    </div>
                  </div>
                </div>
              </div>
            }
            {
              (isInLoggedInEditProfileMode) ?
                <SaveButtonContainer className="row mt-2">
                  {!_.isEmpty(status) && (
                    <div className="col-12 offset-md-5 col-md-7 ">
                      <StatusContainer
                        className={classNames('text-center alert', {
                          'alert-success': isSuccessSubmit,
                          'alert-danger': !isSuccessSubmit,
                        })}
                      >
                        <I18N>{status.message}</I18N>
                      </StatusContainer>
                    </div>
                  )}
                  <CancelButton
                    isShow="true"
                    onClick={() => {
                      if (entryFromPublicPortal) {
                        navigate('./portal-home')
                      } else {
                        navigate('./home');
                      }
                    }}
                    ebTestValue="ssp_myprofile_button_cancel"
                  />
                  <SaveButton
                    type="button"
                    onClick={() => {
                      setOnClickSave(true);
                      handleSubmit();
                    }}
                    ebTestValue="ssp_myprofile_button_submit"
                    hasContinue={false}
                  />
                </SaveButtonContainer>
                :
                (isNewEditPage) ?
                  <div className="offset-md-3 col-md-9 pr-2.5 mt-5">
                    <div className="row">
                      <CancelButton
                        isShow="true"
                        onClick={() => {
                          goNextPage({ pageUri: 'edit-profile', contactId });
                        }}
                        ebTestValue="ssp_myprofile_button_cancel"
                      />
                      <SaveButton
                        type="button"
                        onClick={() => {
                          setOnClickSave(true);
                          handleSubmit();
                        }}
                        ebTestValue="ssp_myprofile_button_submit"
                        hasContinue={false}
                      />
                    </div>
                  </div>
                  :
                  <SaveButtonContainer className="row mt-2">
                    {!_.isEmpty(status) && (
                      <StatusContainer
                        className={classNames('text-center alert', {
                          'alert-success': isSuccessSubmit,
                          'alert-danger': !isSuccessSubmit,
                        })}
                      >
                        <I18N>{status.message}</I18N>
                      </StatusContainer>
                    )}
                    <SaveAndContinueButton
                      type="button"
                      onClick={() => {
                        setOnClickSave(true);
                        handleSubmit();
                      }}
                      ebTestValue="ssp_myprofile_button_submit"
                    />
                  </SaveButtonContainer>
            }
          </div>
        </div>
      </form>
    </div>
  );
};
InnerForm.defaultProps = {
  contactPaths: [],
  status: {},
  minContactPathNum: 0,
};
InnerForm.propTypes = {
  touched: PropTypes.shape().isRequired,
  contactPaths: PropTypes.arrayOf(PropTypes.shape()),
  values: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    suffix: PropTypes.string,
    middleInitial: PropTypes.string,
    externalId: PropTypes.string,
    preferredLanguage: PropTypes.string,
    timeZone: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape().isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  status: PropTypes.shape({
    message: PropTypes.string,
    success: PropTypes.bool,
  }),
  preferredLanguageList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayLabel: PropTypes.string.isRequired,
  })),
  setFieldTouched: PropTypes.func.isRequired,
  contactPathError: PropTypes.shape().isRequired,
  setContactPathError: PropTypes.func.isRequired,
  isNeedValidation: PropTypes.bool.isRequired,
  setIsNeedValidation: PropTypes.func.isRequired,
  isMinContactPathNumShow: PropTypes.bool.isRequired,
  minContactPathNum: PropTypes.number,
  contactId: PropTypes.number.isRequired,
  profileTimeZones: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isAllFieldMandatory: PropTypes.bool.isRequired,
  isTimeZoneExposed: PropTypes.bool.isRequired,
  isTimeZoneEditable: PropTypes.bool.isRequired,
  isTimeZoneMandatory: PropTypes.bool.isRequired,
};

const ProfileForm = withFormik({
  mapPropsToValues: props => ({
    firstName: props.firstName,
    lastName: props.lastName,
    timeZone: props.timeZone,
    preferredLanguage: props.preferredLanguage,
    suffix: props.suffix,
    middleInitial: props.middleInitial,
    externalId: props.externalId,
    contactPaths: props.contactPaths,
    email: props.registrationEmail,
    isEmailEditable: props.isEmailEditable
  }),
  enableReinitialize: true,
  validateOnBlur: true,
  validateOnChange: false,
  validationSchema: props => {
    const { profileValidation } = props;
    return profileValidation;
  },
  validate: (values, props) => {
    const { setIsNeedValidation, setSavedSucceed } = props;
    setIsNeedValidation(true);
    setSavedSucceed(false);
  },
  handleSubmit: (values, formikBag) => {
    const { props, setSubmitting, setStatus } = formikBag;
    const { isInLoggedInEditProfileMode } = props;
    let resolver = null;
    const validationPromise = new Promise((resolve) => {
      resolver = resolve;
    });
    const input = document.getElementsByClassName('js_blur');
    if (input.length < 1) {
      resolver();
    } else {
      const htmlEvent = document.createEvent('HTMLEvents');
      htmlEvent.initEvent('blur', false, true);
      htmlEvent.formSubmit = {};
      htmlEvent.validationCtrl = {
        resolver,
        size: input.length
      };
      for (let i = 0; i < input.length; i++) {
        input[i].dispatchEvent(htmlEvent);
      }
    }
    validationPromise.then(() => {
      const {
        contactPathError,
        validateField,
        minContactPathNum,
        setIsMinContactPathNumShow,
        showAddress,
        showCustomfield,
        showAlertSubscription,
        showGroupSubscription,
        showIncidentSub,
        contactId,
        orgCountry,
        setSavedSucceed,
        setOnClickSave
      } = props;
      if (!_.isEmpty(contactPathError)) {
        return;
      }
      const contactPathParam = [];
      validateField();
      setStatus(null);
      const formatNumber = value => {
        if (value && typeof value === 'string') {
          return value.replace(/[^0-9]/g, '');
        }
        return value;
      };
      const getNationalSignificantNumber = (number, country) => {
        try {
          const parsedNumber = parsePhoneNumber(number, country.toUpperCase());
          return parsedNumber.nationalNumber;
        } catch (e) {
          return formatNumber(number);
        }
      };
      const { contactPaths } = values;
      const CONTACT_PATHS_PHONE_TYPES = ['TTYTDD', 'TA', 'FAX', 'PAGER', 'PHONE', 'SMS'];
      contactPaths.forEach(item => {
        const paramObj = {};
        paramObj.countryCode = item.countryCode || _.toUpper(orgCountry);
        paramObj.noValidate = item.noValidate;
        paramObj.pathId = item.pathId;
        if (isInLoggedInEditProfileMode) {
          paramObj.pathEnable = item.pathEnable;
        }
        if (item.quietTimeFrames) {
          item.quietTimeFrames.forEach((frame) => {
            delete frame.fromMilliSec;
            delete frame.toMilliSec;
          });
        }
        paramObj.quietTimeFrames = item.quietTimeFrames;
        if (item.type === 'PHONE' || item.type === 'SMS' || item.type === 'TTYTDD') {
          paramObj.waitTime = item.waitTime;
        }
        paramObj.systemRequirement = item.systemRequirement;
        if (item.ext || item.pin) {
          paramObj.phoneExt = item.phoneExt;
        }
        paramObj.type = item.type;
        if (_.includes(CONTACT_PATHS_PHONE_TYPES, item.type)) {
          paramObj.value = item.noValidate
            ? formatNumber(item.value)
            : getNationalSignificantNumber(item.value, item.countryCode);
        } else {
          paramObj.value = item.value;
        }

        if (item.value) {
          contactPathParam.push(paramObj);
        }
      });

      if (contactPathParam.length < minContactPathNum) {
        setIsMinContactPathNumShow(true);
        document.getElementById('minContactPath-error').focus();
        setOnClickSave(false);
        return;
      }
      setIsMinContactPathNumShow(false);
      const profiles = _.pickBy(values, (value, key) => !key.includes('contactPath'));
      props.onSubmit(
        profiles,
        contactPathParam,
        () => {
          if (isInLoggedInEditProfileMode) {
            setSavedSucceed(true);
            setSubmitting(false);
          } else {
            goNextPage({
              pageUri: 'edit-profile',
              showAddress,
              showAlertSubscription,
              showGroupSubscription,
              showIncidentSub,
              showCustomfield,
              contactId
            });
          }
        },
        () => {
          setStatus({
            message: 'ssp.register.saveProfile.fail',
            success: false,
          });
          setSavedSucceed(false);
          setSubmitting(false);
        },
      );
    });
  },
})(InnerForm);

ProfileForm.propTypes = {
  onSubmit: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  suffix: PropTypes.string,
  middleInitial: PropTypes.string,
  externalId: PropTypes.string,
  preferredLanguage: PropTypes.string,
  isPreferredLanguageEditable: PropTypes.bool,
  isPreferredLanguageMandatory: PropTypes.bool,
  registrationEmail: PropTypes.string.isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  profileValidation: PropTypes.shape().isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  contactPathError: PropTypes.shape().isRequired,
  setContactPathError: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  isNeedValidation: PropTypes.bool.isRequired,
  setIsNeedValidation: PropTypes.func.isRequired,
  isMinContactPathNumShow: PropTypes.bool.isRequired,
  setIsMinContactPathNumShow: PropTypes.func.isRequired,
  minContactPathNum: PropTypes.number,
  showAddress: PropTypes.bool.isRequired,
  showCustomfield: PropTypes.bool.isRequired,
  showAlertSubscription: PropTypes.bool.isRequired,
  showGroupSubscription: PropTypes.bool.isRequired,
  showIncidentSub: PropTypes.bool.isRequired,
  orgCountry: PropTypes.string.isRequired,
  preferredLanguage: PropTypes.string.isRequired,
  profileTimeZones: PropTypes.arrayOf(PropTypes.shape({
    displayLabel: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  })).isRequired,
  profilesData: PropTypes.any.isRequired,
  setSavedSucceed: PropTypes.func.isRequired,
  isTimeZoneExposed: PropTypes.bool.isRequired,
  isTimeZoneEditable: PropTypes.bool.isRequired,
};

ProfileForm.defaultProps = {
  onSubmit: () => { },
  firstName: '',
  lastName: '',
  contactPaths: [{}],
  suffix: '',
  middleInitial: '',
  externalId: '',
  profileValidation: '',
  timeZone: '',
  minContactPathNum: 0,
  preferredLanguageList: [],
};

export default ProfileForm;
